import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _AvailableActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ActionMutationProvider } from './action-mutation-provider';
import * as TrackingActions from '../../config/constants/tracking-actions';
import ActionPicked from './picked';
import ActionReceived from './received';
import ActionNotReceived from './not-received';
import ActionHelp from './help';
import ActionNecessaryAction from './necessary-action';
import ActionAcceptNewEstimatedDeliveryDate from './accept-new-estimated-delivery-date';
import ActionRefuseNewEstimatedDeliveryDate from './refuse-new-estimated-delivery-date';
import ActionAcceptRetention from './accept-retention-action';
import ActionRefuseRetention from './refuse-retention-action';
import ActionReturnOrExchange from './return-or-exchange';
import { useTrackingOccurence } from '../../hooks/use-tracking-occurrence';
var AvailableActions = (_AvailableActions = {}, _defineProperty(_AvailableActions, TrackingActions.RECEIVED, ActionReceived), _defineProperty(_AvailableActions, TrackingActions.PICKED, ActionPicked), _defineProperty(_AvailableActions, TrackingActions.NOT_RECEIVED, ActionNotReceived), _defineProperty(_AvailableActions, TrackingActions.HELP, ActionHelp), _defineProperty(_AvailableActions, TrackingActions.NECESSARY_ACTION, ActionNecessaryAction), _defineProperty(_AvailableActions, TrackingActions.ACCEPT_NEW_ESTIMATED_DELIVERY_DATE, ActionAcceptNewEstimatedDeliveryDate), _defineProperty(_AvailableActions, TrackingActions.REFUSE_NEW_ESTIMATED_DELIVERY_DATE, ActionRefuseNewEstimatedDeliveryDate), _defineProperty(_AvailableActions, TrackingActions.ACCEPT_RETENTION, ActionAcceptRetention), _defineProperty(_AvailableActions, TrackingActions.REFUSE_RETENTION, ActionRefuseRetention), _defineProperty(_AvailableActions, TrackingActions.RETURN_OR_EXCHANGE, ActionReturnOrExchange), _AvailableActions);
export function RenderActionButton(_ref) {
  var action = _ref.action,
      packageId = _ref.packageId;
  var trackingOccurrence = useTrackingOccurence();
  if (!(action in AvailableActions)) return null;

  if (TrackingActions.RETENTION_ACTIONS.includes(action) && !trackingOccurrence) {
    return null;
  }

  var ActionButton = AvailableActions[action];
  return /*#__PURE__*/_jsx(ActionMutationProvider, {
    children: function children(mutation) {
      return /*#__PURE__*/_jsx(ActionButton, _objectSpread(_objectSpread({}, mutation), {}, {
        id: packageId
      }), action);
    }
  });
}